enum CURRENCIES {
	kzt = '₸',
	gel = '₾'
}

export default function () {
	const currency = import.meta.env.VITE_CURRENCY as keyof typeof CURRENCIES;
	return CURRENCIES[currency] || CURRENCIES.kzt;
}
